import React from 'react';
import { Modal } from 'react-bootstrap';
import { BSModal } from '~/components/Bootstrap';

export interface ErrorModalProps {
    description: React.ReactNode;
    handleSubmit?: () => void;
    handleClose: () => void;
    show: boolean;
    title: string;
    showSubmit?: boolean;
}
export function ErrorModal({
    title,
    description,
    handleSubmit,
    handleClose,
    show = false,
    showSubmit = false,
}: ErrorModalProps) {
    return (
        <BSModal show={show} onHide={handleClose} aria-labelledby="error-modal">
            <Modal.Header closeButton>
                <Modal.Title role="heading" aria-level={1} id="error-modal">
                    {title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <span>{description}</span>
            </Modal.Body>
            <Modal.Footer>
                {showSubmit && (
                    <button type="submit" className="btn btn-primary" onClick={handleSubmit}>
                        Submit
                    </button>
                )}

                <button className="btn btn-secondary" type="button" onClick={handleClose}>
                    Dismiss
                </button>
            </Modal.Footer>
        </BSModal>
    );
}
